import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const mutation = gql`
  mutation AddReaction($reaction: RecognitionFeedReactionInput!) {
    addReaction(reaction: $reaction) {
      uuid
      parentId
      authorId
      emoji {
        code
        name
      }
    }
  }
`
export const addReactionMutationKey = getQueryNames(mutation)[0]

export default mutation
